export enum ControlledDocumentStatusEnum {
  IN_DRAFT = 'In Draft',
  SUBMITTED = 'Submitted',
  IN_REVIEW = 'In Review',
  IN_APPROVAL = 'In Approval',
  APPROVED = 'Approved',
  EFFECTIVE = 'Effective',
  SUPERSEDED = 'Superseded',
  RETIRE = 'Retire',
  PENDING_RETIREMENT = 'Pending Retirement',
  OBSOLETE = 'Obsolete',
  CANCELED = 'Canceled',
}
